import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopuneonlinecab() {



  const cardData = {


  keyword: "Mumbai to Pune Online Cab",

  headingDescription: "Trustline Travels offers convenient Mumbai to Pune online cab booking services with safe, comfortable, and affordable taxi solutions for business trips, airport transfers, corporate travel, family journeys, and outstation rides. With easy online booking, professional chauffeurs, and a wide range of vehicles, we ensure a smooth and stress-free travel experience from Mumbai to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury cars suitable for individuals, families, and groups. With transparent fares, doorstep pickup, flexible travel timings, experienced drivers, well-maintained vehicles, and 24/7 customer support, Trustline Travels makes Mumbai to Pune cab booking simple, secure, and reliable.",

  topPlaces: [
    {
      title: "Rajiv Gandhi Infotech Park",
      description: "Rajiv Gandhi Infotech Park in Hinjewadi is Pune's major IT and corporate destination, home to multinational companies, software firms, startups, and business campuses. It is a key location for professionals traveling from Mumbai for work."
    },
    {
      title: "Amanora Park Town",
      description: "Amanora Park Town is a modern integrated township in Pune featuring residential spaces, commercial offices, shopping areas, and lifestyle facilities. It attracts professionals, families, and visitors throughout the year."
    },
    {
      title: "Kharadi Business Zone",
      description: "Kharadi Business Zone is a rapidly developing commercial area known for EON IT Park, corporate offices, technology companies, and premium business infrastructure. It is a preferred destination for IT professionals."
    },
    {
      title: "Bavdhan",
      description: "Bavdhan is a growing residential and commercial locality surrounded by hills, offering premium housing projects, educational institutions, offices, and convenient access to Pune's major business areas."
    },
    {
      title: "Pimple Saudagar",
      description: "Pimple Saudagar is a well-developed residential and commercial area in Pune known for modern housing projects, restaurants, shopping areas, and excellent connectivity to Pimpri Chinchwad and IT hubs."
    },
    {
      title: "Bhosari MIDC",
      description: "Bhosari MIDC is an important industrial destination featuring engineering companies, automobile businesses, manufacturing units, and warehouses. It is a major hub for industrial and corporate travel."
    },
    {
      title: "Raja Dinkar Kelkar Museum",
      description: "Raja Dinkar Kelkar Museum is a famous Pune attraction showcasing a large collection of traditional Indian art, antiques, sculptures, and historical artifacts. It is a popular destination for culture and heritage lovers."
    },
    {
      title: "Pune Okayama Friendship Garden",
      description: "Pune Okayama Friendship Garden is a beautiful Japanese-style landscaped garden featuring peaceful surroundings, greenery, and traditional design elements. It is a relaxing sightseeing spot for families and tourists."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a popular hill station located between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and lush green landscapes. It is a favorite weekend destination for travelers."
    },
    {
      title: "Rajmachi Fort",
      description: "Rajmachi Fort is a historic hill fort near Lonavala known for trekking trails, scenic mountain views, and natural beauty. It attracts adventure lovers, photographers, and nature enthusiasts."
    }
  ],






"services": [
  {
    "name": "Mumbai to Pune Online Cab",
    "description": "Book Mumbai to Pune Online Cab with instant confirmation, professional chauffeurs, clean AC vehicles, affordable fares, doorstep pickup, and comfortable intercity travel."
  },
  {
    "name": "Mumbai Airport to Pune Taxi Online Booking",
    "description": "Book Mumbai Airport to Pune Taxi Online Booking for reliable airport transfers with experienced drivers, luggage support, premium cars, and timely pickup service."
  },
  {
    "name": "Mumbai to Pune Online Innova Taxi",
    "description": "Choose Mumbai to Pune Online Innova Taxi for spacious family travel with premium comfort, AC vehicles, professional drivers, and smooth highway journeys."
  },
  {
    "name": "Mumbai to Pune Online Ertiga Taxi",
    "description": "Book Mumbai to Pune Online Ertiga Taxi for affordable group travel with comfortable seating, clean vehicles, experienced chauffeurs, and flexible booking."
  },
  {
    "name": "Mumbai to Pune Online Round Trip Taxi",
    "description": "Reserve Mumbai to Pune Online Round Trip Taxi with flexible return timing, transparent pricing, premium vehicles, and reliable chauffeur service."
  },
  {
    "name": "Online Cab Booking Mumbai to Pune",
    "description": "Complete Online Cab Booking Mumbai to Pune for quick reservation, multiple vehicle options, affordable fares, and safe intercity transportation."
  },
  {
    "name": "Mumbai to Pune 24x7 Cab Booking",
    "description": "Book Mumbai to Pune 24x7 Cab Booking anytime with professional drivers, clean AC cars, instant availability, and reliable travel support."
  },
  {
    "name": "Online Cab Booking Pune to Mumbai",
    "description": "Choose Online Cab Booking Pune to Mumbai for convenient return travel with easy booking, fixed pricing, comfortable vehicles, and experienced chauffeurs."
  },
  {
    "name": "Mumbai Online Cab Booking",
    "description": "Get Mumbai Online Cab Booking service for airport transfers, outstation trips, corporate travel, and personal journeys with reliable vehicles."
  },
  {
    "name": "Online Taxi Booking Mumbai",
    "description": "Book Online Taxi Booking Mumbai for safe and comfortable travel with professional drivers, AC cars, affordable fares, and quick confirmation."
  },
  {
    "name": "Mumbai Airport Taxi Booking Online",
    "description": "Reserve Mumbai Airport Taxi Booking Online with airport pickup, trained chauffeurs, clean vehicles, transparent pricing, and hassle-free travel."
  },
  {
    "name": "Taxi Booking in Mumbai",
    "description": "Choose Taxi Booking in Mumbai for reliable local and outstation travel with multiple car options, professional service, and affordable rates."
  },
  {
    "name": "Online Cab Service in Mumbai",
    "description": "Book Online Cab Service in Mumbai for convenient transportation with experienced drivers, comfortable vehicles, and 24x7 customer assistance."
  },
  {
    "name": "Online Cab in Mumbai",
    "description": "Get Online Cab in Mumbai for quick travel solutions with easy booking, clean cars, affordable fares, and dependable chauffeur service."
  },
  {
    "name": "Online Taxi Booking from Mumbai Airport",
    "description": "Book Online Taxi Booking from Mumbai Airport for smooth airport transfers with premium cars, professional drivers, and timely service."
  },
  {
    "name": "Mumbai to Pune One Way Cab",
    "description": "Choose Mumbai to Pune One Way Cab for direct destination travel with fixed fares, comfortable vehicles, and professional chauffeurs."
  },
  {
    "name": "Mumbai to Pune Cab Service",
    "description": "Book Mumbai to Pune Cab Service for safe intercity travel with AC vehicles, experienced drivers, affordable pricing, and reliable support."
  },
  {
    "name": "Book Mumbai to Pune Cab Online",
    "description": "Book Mumbai to Pune Cab Online with instant confirmation, flexible schedules, multiple vehicle choices, and convenient doorstep pickup."
  },
  {
    "name": "Mumbai to Pune Online Taxi",
    "description": "Reserve Mumbai to Pune Online Taxi for comfortable journeys with premium cars, transparent pricing, and professional chauffeur-driven service."
  },
  {
    "name": "Mumbai to Pune Private Cab Booking",
    "description": "Choose Mumbai to Pune Private Cab Booking for exclusive travel with privacy, flexible timing, clean vehicles, and experienced drivers."
  },
  {
    "name": "Mumbai to Pune Outstation Cab",
    "description": "Book Mumbai to Pune Outstation Cab for reliable long-distance travel with safe highway journeys, AC cars, and professional chauffeurs."
  },
  {
    "name": "Mumbai to Pune Drop Taxi",
    "description": "Choose Mumbai to Pune Drop Taxi for affordable one-way travel with direct drop service, fixed pricing, and comfortable transportation."
  },
  {
    "name": "Mumbai to Pune Cheap Cab Booking",
    "description": "Get Mumbai to Pune Cheap Cab Booking with budget-friendly fares, quality vehicles, reliable drivers, and easy online reservation."
  }
],

"tableData": [
  ["Mumbai to Pune Online Cab", "Mumbai Airport to Pune Taxi Online Booking"],
  ["Mumbai to Pune Online Innova Taxi", "Mumbai to Pune Online Ertiga Taxi"],
  ["Mumbai to Pune Online Round Trip Taxi", "Online Cab Booking Mumbai to Pune"],
  ["Mumbai to Pune 24x7 Cab Booking", "Online Cab Booking Pune to Mumbai"],
  ["Mumbai Online Cab Booking", "Online Taxi Booking Mumbai"],
  ["Mumbai Airport Taxi Booking Online", "Taxi Booking in Mumbai"],
  ["Online Cab Service in Mumbai", "Online Cab in Mumbai"],
  ["Online Taxi Booking from Mumbai Airport", "Mumbai to Pune One Way Cab"],
  ["Mumbai to Pune Cab Service", "Book Mumbai to Pune Cab Online"],
  ["Mumbai to Pune Online Taxi", "Mumbai to Pune Private Cab Booking"],
  ["Mumbai to Pune Outstation Cab", "Mumbai to Pune Drop Taxi"],
  ["Mumbai to Pune Cheap Cab Booking", ""]
],





whychoose: [
  {
    WhyChooseheading: "Easy Mumbai to Pune Online Cab Booking",
    WhyChoosedescription: "Trustline Cab provides a simple online cab booking facility for Mumbai to Pune travel with quick confirmation, comfortable vehicles, and reliable service."
  },
  {
    WhyChooseheading: "Instant Booking & Quick Response",
    WhyChoosedescription: "Get fast assistance for fare details, vehicle selection, and booking confirmation to plan your Mumbai to Pune journey smoothly."
  },
  {
    WhyChooseheading: "Trusted Drivers & Safe Travel",
    WhyChoosedescription: "Our verified drivers ensure secure and comfortable travel with excellent knowledge of Mumbai-Pune routes and expressway conditions."
  },
  {
    WhyChooseheading: "Multiple Cars Available Online",
    WhyChoosedescription: "Book Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers online based on your passenger and luggage requirements."
  },
  {
    WhyChooseheading: "Transparent Online Cab Pricing",
    WhyChoosedescription: "Know your fare details before confirming your ride with clear pricing and no hidden charges during the booking process."
  },
  {
    WhyChooseheading: "Pickup Anywhere in Mumbai",
    WhyChoosedescription: "Book doorstep pickup from Mumbai Airport, railway stations, hotels, offices, and residential areas with direct drop in Pune."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "Choose one-way trips, round trips, airport transfers, or customized cab packages according to your travel plans."
  },
  {
    WhyChooseheading: "24/7 Online Booking Support",
    WhyChoosedescription: "Our support team is available anytime to assist with online bookings, travel queries, and vehicle requirements."
  }
]

};

const faqData = [
  {
    question: "How can I book Mumbai to Pune cab online?",
    answer: "You can book a Mumbai to Pune cab online by sharing your pickup location, destination, travel date, passenger details, and preferred vehicle."
  },
  {
    question: "Does Trustline Cab offer online cab booking for Mumbai to Pune?",
    answer: "Yes, Trustline Cab provides convenient online booking options with quick confirmation and reliable cab service."
  },
  {
    question: "Can I book a one-way Mumbai to Pune cab online?",
    answer: "Yes, online one-way cab booking is available for passengers who need direct travel from Mumbai to Pune."
  },
  {
    question: "Which cars can I book online for Mumbai to Pune travel?",
    answer: "You can book Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your needs."
  },
  {
    question: "Can I schedule my online cab booking in advance?",
    answer: "Yes, advance online booking is available and recommended to secure your preferred vehicle and travel timing."
  },
  {
    question: "Do you provide online booking from Mumbai Airport to Pune?",
    answer: "Yes, you can book airport transfer cabs online from Mumbai Airport to Pune with convenient pickup arrangements."
  },
  {
    question: "Is Mumbai to Pune online cab service available 24 hours?",
    answer: "Yes, online booking assistance is available 24/7 for comfortable travel planning."
  },
  {
    question: "Are cab fares shared before online booking confirmation?",
    answer: "Yes, fare details are provided clearly before confirmation so customers can make informed booking decisions."
  },
  {
    question: "Can companies book Mumbai to Pune cabs online?",
    answer: "Yes, corporate travelers and companies can book reliable transportation solutions online for regular and business travel."
  },
  {
    question: "Why choose Trustline Travels for Mumbai to Pune online cab booking?",
    answer: "Trustline Travels offers easy booking, professional drivers, comfortable vehicles, transparent pricing, and dependable travel support."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harshad Patil",
    feedback: "The online booking process was quick and convenient. Trustline Travels provided a clean vehicle, timely updates, and a smooth Mumbai to Pune journey with excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Desai",
    feedback: "Booking a cab online was simple and hassle-free. The driver was professional, the vehicle was comfortable, and the complete travel experience was excellent.",
    rating: 5
  }
];





  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Online Cab",
  "image": "https://www.trustlinetravels.com/assets/images/mumbai-to-pune-online-cab.webp",
  "description":
    "Book Mumbai to Pune Online Cab with Trustline Travels for safe, comfortable, and affordable taxi services. Enjoy easy online cab booking from Mumbai to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs. We provide one-way, round-trip, and Mumbai Airport to Pune taxi services with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mumbai-to-pune-online-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Pune Online Cab | Online Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mumbai to Pune Online Cab with Trustline Travels for reliable 24x7 taxi services. Easy online cab booking for Mumbai to Pune, Mumbai Airport to Pune, one-way, round-trip, Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs at affordable fares."
  />

  <meta
    name="keywords"
    content="mumbai to pune online cab, mumbai airport to pune taxi online booking, mumbai to pune online innova taxi, mumbai to pune online ertiga taxi, mumbai to pune online round trip taxi, online cab booking mumbai to pune, mumbai to pune 24x7 cab booking, online cab booking pune to mumbai, mumbai to pune online taxi booking, mumbai pune online cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/104.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopuneonlinecab;